import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Constants
import { CITY, LLD, LATLON } from '../constants'

// Styles
import { lightGrey, white } from 'hfty-styles/src/colors'

export default class Category extends Component {
  constructor() {
    super()
    this.onSelect = this.onSelect.bind(this)
  }

  onSelect() {
    this.props.onSelectCategory({ category: this.props.category })
  }

  render() {
    return (
      <div
        data-test="Category"
        onClick={this.onSelect}
        style={{
          color: this.props.active ? white() : lightGrey(),
          cursor: 'pointer',
          padding: this.props.active ? '10px 10px' : '0px 0px',
        }}
      >
        {this.props.category}
      </div>
    )
  }
}

Category.propTypes = {
  active: PropTypes.bool.isRequired,
  category: PropTypes.oneOf([CITY, LATLON, LLD]).isRequired,
  onSelectCategory: PropTypes.func.isRequired,
}
